export default __webpack_public_path__ + "static/media/02.b2a8ddaf.png";